import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
// import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import WalletList from '../../components/WalletHistoryList/list';

const WalletHistoryPage =() => {
    return(
        <Fragment>
            <Navbar/>
            <WalletList />
            {/* <Footer footerClass={'wpo-ne-footer-2'}/> */}
            <Scrollbar/>
        </Fragment>
    )
};
export default WalletHistoryPage;